<div class="nav-item-container min-w-full py-3 pl-4 text-lg
                hover:text-on-surface-container hover:bg-tertiary-container"
     [ngClass]="disabled()
       ? 'bg-surface-container-high hover:cursor-not-allowed'
       : 'hover:cursor-pointer'">
    <a mat-list-item (click)="onClick()" class="">
        <div class="flex items-center gap-4"><mat-icon class="nav-icon">{{icon()}}</mat-icon>{{text()}}</div>
    </a>
</div>
